import { PAGE_LEVEL } from '@/constants';

/**
 * Test IRM 页面路由：内嵌 testirm.comein.cn iframe
 */
export default {
  path: '/test-irm',
  redirect: '/test-irm/index',
  children: [
    {
      path: 'index',
      name: 'testIrmIndex',
      component: () => import('@/pages/testIrm/index.vue'),
      meta: {
        componentName: 'TestIrmIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'Test IRM',
        keepAlive: true,
        // 该页面未纳入后端菜单权限，跳过路由守卫的菜单鉴权，否则会被重定向到 /res/not-found
        requireAuth: false
      }
    }
  ]
};
